import React from "react"
import Article from '../Article'

function HowToUse(props) {

  const content = `<p>Através da tela inicial do Simular, escolha a marca.</p>
  
  <p><img alt="" src="/images/como-utilizar-1.png" /></p>
  
  <p>Escolha um dos tipos de ambiente, ou faça o upload do seu ambiente atra'ves do item ”seu ambiente”.</p>
  
  <p><img alt="" src="/images/como-utilizar-2.png" /></p>

  <p>A partir dos filtros escolha o estilo do ambiente, acesse a galeria.</p>
  
  <p><img alt="" src="/images/como-utilizar-3.png" /></p>

  <p>Compartilhe a sua escolha através do ícone de compartilhamento.</p>
  
  <p><img alt="" src="/images/como-utilizar-4.png" /></p>

  <p>Ao finalizar a simulação, conte-nos o que achou da experiência.</p>
  
  <p><img alt="" src="/images/como-utilizar-5.png" /></p>

  <p>Preencha o feedback e envie seu comentário através do botão ”Submit”.</p>
  
  <p><img alt="" src="/images/como-utilizar-6.png" /></p>
  
  `


  return (
    <Article article={content} title='Como Utilizar'/>
    )
  
}

export default HowToUse
